import PropTypes from 'prop-types'

import DDIcon from '../../icons/DDIcon'
import CopyButton from './CopyButton'
import styles from './DataTable.module.css'

// Spec §5.8 — used for transfer details (05) and the mandate-created summary (07/R4).
// Rows with `copyable` get a CopyButton next to the value (e.g. account number).
const DataTable = ({ rows, onCopy }) => (
  <div className={styles.table}>
    {rows.map((row) => (
      <div key={row.label} className={styles.row}>
        <span className={[styles.labelCell, row.labelColor === 'secondary' && styles.secondary].filter(Boolean).join(' ')}>
          {row.icon && <DDIcon name={row.icon} />}
          {row.label}
        </span>
        <span className={styles.valueCell}>
          {row.value}
          {row.copyable && (
            <CopyButton text={row.value} label={`Copy ${row.label}`} onCopied={() => onCopy?.(row.label)} />
          )}
        </span>
      </div>
    ))}
  </div>
)

DataTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      copyable: PropTypes.bool,
      labelColor: PropTypes.oneOf(['primary', 'secondary']),
    }),
  ).isRequired,
  onCopy: PropTypes.func,
}

export default DataTable
